import { getAppEndpointVersion } from 'helpers'
import axios from './axiosInstance'
import constants from '../constants'

export default function init() {
}

export async function getAppMessages(app, apiHost, type = 'current', id = 0) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  if (type === 'previous') {
    URL = `${URL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/messages?hideDeleted=1&limit=30&affix=prepend&id=${id}&categories=custom,message,interactive,agentic`
  } else if (type === 'next') {
    if (id > 0)
      URL = `${URL}${apiHost}/${getAppEndpointVersion(
        app,
      )}/messages?hideDeleted=1&limit=30&affix=append&id=${id}&categories=custom,message,interactive,agentic`
    else
      URL = `${URL}${apiHost}/${getAppEndpointVersion(
        app,
      )}/messages?hideDeleted=1&limit=30&categories=custom,message,interactive,agentic`
  } else {
    URL = `${URL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/messages?hideDeleted=1&limit=30&categories=custom,message,interactive,agentic`
  }
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function searchAppMessages(app, apiHost, fromDate, toDate, type = 'current', id = 0) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'

  URL = `${URL}${apiHost}/${getAppEndpointVersion(
    app,
  )}/messages?fromTimestamp=${fromDate}&toTimestamp=${toDate}&hideDeleted=1&limit=500&categories=custom,message,interactive,agentic`
  if (type === 'previous') {
    URL = `${URL}&affix=prepend&id=${id}`
  }
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function exportAppMessages(app, apiHost, type = 'current', sentAt = 0, id = 0) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'

  if (type === 'previous') {
    URL = `${URL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/messages?sentAt=${sentAt}&hideDeleted=1&limit=1000&affix=prepend&id=${id}&categories=custom,message,interactive,agentic`
  } else {
    URL = `${URL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/messages?hideDeleted=1&limit=1000&categories=custom,message,interactive,agentic`
  }
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getModerationMessages(app, apiHost, id = 0) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  if (id > 0)
    URL = `${URL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/users/app_system/messages?hideDeleted=1&per_page=50&category=custom&type=extension_human-moderation&affix=append&id=${id}`
  else
    URL = `${URL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/users/app_system/messages?hideDeleted=1&per_page=50&category=custom&type=extension_human-moderation&affix=append&id=0.5`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function deleteAppMessageLog(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/messages/${id}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function rejectModMessageLogs(message, app) {
  // PTM ADD THE URL
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}human-moderation-${app.region}.cometchat.io/v1/reject`
  // change the headers
  return axios
    .post(`${URL}`, message, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatAPIVersion: getAppEndpointVersion(app),
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function approveModMessageLogs(message, app) {
  // PTM ADD THE URL
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}human-moderation-${app.region}.cometchat.io/v1/approve`
  return axios
    .post(`${URL}`, message, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatAPIVersion: getAppEndpointVersion(app),
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function add(payload, id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${id}/messages`
  return axios
    .post(`${URL}`, payload, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getGroupMessages(app, guid = 0) {
  const URL = `${constants.customerDomain}groups/${guid}/messages?hideDeleted=1&limit=100`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function deleteGroupMessageLog(id, app) {
  const URL = `${constants.customerDomain}messages/159552124900000001`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getAppMessageByID(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'

  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/messages/${id}`

  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getUserMessages(app, apiHost, userUid, onBehalfOfUid, params = {}) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  const query = Object.keys(params)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&')
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${encodeURIComponent(
    userUid,
  )}/messages${query ? `?${query}` : ''}`
  const headers = {
    appId: app.id,
    apiKey: app.accessKey,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }
  if (onBehalfOfUid) headers.onBehalfOf = onBehalfOfUid

  return axios
    .get(`${URL}`, {
      headers,
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response?.data || { error: 'Failed to fetch user messages' }
    })
}

export async function getMessages(app, apiHost, params = {}, onBehalfOfUid) {
  // params: object with query params like perPage, limit, fromTimestamp, toTimestamp, etc.
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  const withTs = { ...params, ts: Date.now() }
  const query = Object.keys(withTs)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(withTs[k])}`)
    .join('&')
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/messages${query ? `?${query}` : ''}`
  const headers = {
    appId: app.id,
    apiKey: app.accessKey,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }
  if (onBehalfOfUid) headers.onBehalfOf = onBehalfOfUid

  return axios
    .get(`${URL}`, {
      headers,
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response?.data || { error: 'Failed to fetch messages' }
    })
}
